var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('iframe',{attrs:{"src":_vm.url,"width":_vm.width,"height":_vm.height,"frameBorder":"0"}}),_c('div',{on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Go Back")])])}
var staticRenderFns = []

export { render, staticRenderFns }